import { render, staticRenderFns } from "./InputRadioGroup.vue?vue&type=template&id=091af2a3"
import script from "./InputRadioGroup.vue?vue&type=script&lang=ts"
export * from "./InputRadioGroup.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports